import ugr from '@/UGRoute';
import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
const ClientPublicRoute = () => {
    const isLoggedIn = sessionStorage.getItem('isActive');    
    if (!isLoggedIn) {
        return <Outlet />
    } else {
        return <Navigate to={`/${ugr}/client/product`} />
    }


}
export default ClientPublicRoute